import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';
import bgImage from '../images/background.png';
import wine404Anim from '../animations/wine-404.json';

export default function NoPage() {
    const { t } = useTranslation();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        requestAnimationFrame(() => setReady(true));
    }, []);

    return (
        <div className={`nf-stage ${ready ? 'nf-ready' : ''}`}>
            <div className="nf-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="nf-vignette" />
            <div className="nf-grain" />

            <div className="nf-content">
                <div className="nf-lottie-wrap">
                    <Lottie animationData={wine404Anim} loop className="nf-lottie" />
                </div>
                <div className="nf-ornament">
                    <span />
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M5 0L6.12 3.88L10 5L6.12 6.12L5 10L3.88 6.12L0 5L3.88 3.88L5 0Z" fill="#c9a96e"/>
                    </svg>
                    <span />
                </div>
                <h1 className="nf-title">{t('no_page.headline')}</h1>
                <p className="nf-sub">{t('no_page.sub')}</p>
                <Link to="/" className="nf-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M5 12l7-7M5 12l7 7"/>
                    </svg>
                    {t('no_page.cta')}
                </Link>
            </div>
        </div>
    );
}
